import defaultTransition from './default';
import toCaseTransition from './to-case';

export default [defaultTransition, toCaseTransition];